import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'スタッフ管理',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 5,
  staffOnly: true,
};
